<template>
  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li class="active">
                <span>Subscription Plans</span>
              </li>
            </ol>
          </div>
          <h2 class="font-light m-b-xs">
            LEA subscription plans
          </h2>
          <small>Try the platform before confirming your subscription</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="row">
        <div class="col-xs-12">
          <div class="hpanel">
            <div class="panel-body">
              <div class="table-responsive" id="lea-plans-content">
                <table class="table table-bordered table-striped">
                  <thead>
                  <tr>
                    <th class="no-border-top no-border-left">&nbsp;</th>
                    <th class="text-center">
                      <h3 class="font-bold text-info no-margins">Basic</h3>
                      <span class="m-b-xs">Free expertise search</span>
                    </th>
                    <th class="text-center">
                      <h3 class="font-bold text-info no-margins">Seeker</h3>
                      <span class="m-b-xs">Advanced search & knowledge management</span>
                    </th>
                    <th class="text-center">
                      <h3 class="font-bold text-info no-margins">Broker</h3>
                      <span class="m-b-xs">Full Open Innovation service</span>
                    </th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr>
                    <th>Schneider Electric Edison experts search <span>Search and contact through Schneider Electric IDS /Spice portal</span></th>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                  </tr>
                  <tr>
                    <th>External experts search<span>Confidential contact possible with Broker account - see below</span></th>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                  </tr>
                  <tr>
                    <th>Advanced search <span>Type of source: Patents, Companies, Science publications</span></th>
                    <td class="text-center"><span class="btn-danger btnDisable"><i class="fa fa-times"></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                  </tr>
                  <tr>
                    <th>Advanced search  <span>Filters : date, geographies, boolean…</span></th>
                    <td class="text-center"><span class="btn-danger btnDisable"><i class="fa fa-times"></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                  </tr>
                  <tr>
                    <th>Build advanced bibliography<span>Search, mindmap structure, save, share</span></th>
                    <td class="text-center"><span class="btn-danger btnDisable"><i class="fa fa-times"></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                  </tr>
                  <tr>
                    <th>Project mode advanced search <span>Creating projects and portfolios, search in specific projects, project management</span></th>
                    <td class="text-center"><span class="btn-danger btnDisable"><i class="fa fa-times"></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                  </tr>
                  <tr>
                    <th>Dedicated Open innovation workflows <span>For the user’s needs: State of the art, Problem Solving, Technology Transfer…</span></th>
                    <td class="text-center"><span class="btn-danger btnDisable"><i class="fa fa-times"></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                    <td class="text-center"><span class="btn-success btnEnable"><i class="fa fa-check "></i></span></td>
                  </tr>
                  <tr>
                    <th>All expert contacting through LEA platform <span>With confidentiality and with the support of LEA provider (ideXlab experts)</span></th>
                    <td class="text-center"><span class="btn-danger btnDisable"><i class="fa fa-times"></i></span></td>
                    <td class="text-center"><span class="btn-danger btnDisable"><i class="fa fa-times"></i></span></td>
                    <td class="text-center">
                      <span class="btn-success btnEnable"><i class="fa fa-check "></i></span><br>
                      <span class="text-info text-justify m-b-xs">On-demand Open innovation services (2)</span>
                    </td>
                  </tr>
                  <tr>
                    <th>Open Innovation project <span>With assistance by LEA provider (ideXlab experts)</span></th>
                    <td class="text-center"><span class="btn-danger btnDisable"><i class="fa fa-times"></i></span></td>
                    <td class="text-center"><span class="btn-danger btnDisable"><i class="fa fa-times"></i></span></td>
                    <td class="text-center">
                      <span class="btn-success btnEnable"><i class="fa fa-check "></i></span><br>
                      <span class="text-info text-justify m-b-xs">On-demand Open innovation services (2)</span>
                    </td>
                  </tr>
                  </tbody>

                  <tfoot>
                  <tr>
                    <th class="no-border-bottom no-border-left"><h4><b>Subscription plans</b></h4></th>
                    <td class="text-center"><h5>Free + Free Seeker Account Trial (1)</h5></td>
                    <td class="text-center"><router-link class="btn btn-info" :to="{name: 'LeaPayment', params: {role : 'seeker'}}">Create Seeker Account</router-link></td>
                    <td class="text-center"><a class="btn btn-info" href="mailto:lea.se@idexlab.com?subject=information request about broker account">Request Information</a></td>
                  </tr>
                  <tr class="no-border-bottom no-border-left no-border-right">
                    <th class="no-border-left no-border-bottom no-border-right"></th>
                    <td class="text-center no-border-right no-border-left no-border-bottom">
                      <a class="text-success" href="https://schneider-electric.box.com/s/1qy85yoj5nv3ffaep2ginzzvg8hg4nyx" style="font-size: 14px;font-weight: bold;" target="_blank">see 2mn video</a>
                    </td>
                    <td class="text-center no-border-left no-border-bottom no-border-right">
                      <a class="text-success" href="https://schneider-electric.box.com/s/8pcguwhgl9fuofw2fulggmrft4karuya" style="font-size: 14px;font-weight: bold;" target="_blank">see 2mn video</a>
                    </td>
                    <td class="no-border-left no-border-bottom no-border-right"></td>
                  </tr>
                  </tfoot>

                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="hpanel">
            <div class="panel-body">
              <div>
                (1) Free Seeker account trial : Enjoy Seeker features, limited to 25 searches - typically enough for one project -.<br><br>

                (2) Available assistance to full <b>open innovation projects</b>:<br>
                The open innovation workflow provided by LEA - ideXlab’s platform includes the following 6 steps:<br>
                <ul style="list-style-type: decimal" class="m-t-sm">
                  <li class="m-b-sm">
                    <b>Explore</b>: Creating a project, researching, structuring and sharing of a first state-of-the-art
                    around the question of interest
                  </li>
                  <li class="m-b-sm">
                    <b>Question</b>: Formulation and specification of the question to be discussed with the external
                    experts.
                  </li>
                  <li class="m-b-sm">
                    <b>Contact</b>: Confirmation and selection of most relevant experts and contact details collection
                  </li>
                  <li class="m-b-sm">
                    <b>Interact</b>: Anonymised Questions&Answers to spot the most interesting proposals & motivated
                    experts; depending on context, experts might be individuals (academics, researchers,…) or companies
                  </li>
                  <li class="m-b-sm">
                    <b>Rank</b> : Selection of the most interesting experts / proposals
                  </li>
                  <li class="m-b-sm">
                    <b>Implement</b> : Setup & Execute the collaboration agreement (tech transfer, partnership,
                    sub-contracting, …)
                  </li>
                </ul>
                <strong>
                  To set-up an Open Innovation project, please contact ideXlab team:
                  <a href="mailto:lea.se@idexlab.com" class="text-info " target="_blank">
                    lea.se@idexlab.com
                  </a>
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
  th span {
    font-weight: normal;
    font-size: 87.5%;
    color: #999;
    display: block;
  }
  .btnEnable, .btnDisable {
    font-size: 13px;
    padding: 0 3px;
  }
  td {
    vertical-align: middle !important;
  }
  .no-borders {
    border: 1px solid Transparent!important;
  }
  .no-border-top {
    border-top: 1px solid Transparent!important;
  }
  .no-border-bottom {
    border-bottom: 1px solid Transparent!important;
  }
  .no-border-left {
    border-left: 1px solid Transparent!important;
  }
  .no-border-right {
    border-right: 1px solid Transparent!important;
  }

</style>
<script>

export default {
  name: 'LeaPlans',
  beforeMount () {
    this.$salesMachine.visitSubscriptionPlan()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/plan/LeaPlans.vue